// import PropTypes from 'prop-types'
import React, {useRef} from 'react';
import logo from '../imagens/programacao.png'
import 'bootstrap/dist/css/bootstrap.css';
import { FaBars, FaTimes } from 'react-icons/fa';

import '../styles/Header.css';
import '../styles/App.css';


export default function Header() {
    const navRef = useRef();

    const showNavbar = () => {
      navRef.current.classList.toggle('responsive_nav');
    }
  
    return (
      <header className="header">
        <img className="img-logo" src={logo} alt="Logo da página" />
        <nav ref={navRef}>
          <a href="#projetos" >Projetos</a>
          <a href="#sobre" >Sobre</a>
          <a href="#contato" >Contato</a>
          <a href="#inicio" >Início</a>
          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
              <FaTimes />
          </button>
        </nav>
        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </header>
    )

};
